import {useEffect, useState} from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from '../components/Sidebar'
import Header from '../components/Header'


import Users from '../components/Users'
import Experts from '../components/Experts'

import { API_BASE } from '../config/api'


function UserList() {
    return (
        <>
        <Sidebar/>
        <main class="main-content">
            <Header/>
            <div class="content-inner container-fluid pb-0" id="page_layout">
                <Outlet/>
            </div>
        </main>
        </>
    )
}

export default UserList
